// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file protobuf/sell/common/common.proto (package od_protos.sell.common, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file protobuf/sell/common/common.proto.
 */
export const file_protobuf_sell_common_common: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * The marketing channel the seller came in from.
 * Next ID: 4
 *
 * @generated from enum od_protos.sell.common.MarketingChannel
 */
export enum MarketingChannel {
  /**
   * @generated from enum value: UNKNOWN_CHANNEL = 0;
   */
  UNKNOWN_CHANNEL = 0,

  /**
   * From the main website opendoor.com.
   *
   * @generated from enum value: DEFAULT = 1;
   */
  DEFAULT = 1,

  /**
   * From our mobile application.
   *
   * @generated from enum value: APP = 2;
   */
  APP = 2,

  /**
   * From our home value report emails.
   *
   * @generated from enum value: HOME_VALUE = 3;
   */
  HOME_VALUE = 3,
}

/**
 * The marketing channel the seller came in from.
 * Next ID: 4
 *
 * @generated from enum od_protos.sell.common.MarketingChannel
 */
export type MarketingChannelJson = "UNKNOWN_CHANNEL" | "DEFAULT" | "APP" | "HOME_VALUE";

/**
 * Describes the enum od_protos.sell.common.MarketingChannel.
 */
export const MarketingChannelSchema: GenEnum<MarketingChannel, MarketingChannelJson> = /*@__PURE__*/
  enumDesc(file_protobuf_sell_common_common, 0);

/**
 * The timeline the seller has when looking to sell their home.
 * Next ID: 6
 *
 * @generated from enum od_protos.sell.common.Timeline
 */
export enum Timeline {
  /**
   * @generated from enum value: UNKNOWN_TIMELINE = 0;
   */
  UNKNOWN_TIMELINE = 0,

  /**
   * @generated from enum value: ASAP = 1;
   */
  ASAP = 1,

  /**
   * 2 - 4 weeks
   *
   * @generated from enum value: WEEKS_2_4 = 2;
   */
  WEEKS_2_4 = 2,

  /**
   * 4 - 6 weeks
   *
   * @generated from enum value: WEEKS_4_6 = 3;
   */
  WEEKS_4_6 = 3,

  /**
   * 6+ weeks
   *
   * @generated from enum value: WEEKS_6_PLUS = 4;
   */
  WEEKS_6_PLUS = 4,

  /**
   * @generated from enum value: JUST_BROWSING = 5;
   */
  JUST_BROWSING = 5,
}

/**
 * The timeline the seller has when looking to sell their home.
 * Next ID: 6
 *
 * @generated from enum od_protos.sell.common.Timeline
 */
export type TimelineJson = "UNKNOWN_TIMELINE" | "ASAP" | "WEEKS_2_4" | "WEEKS_4_6" | "WEEKS_6_PLUS" | "JUST_BROWSING";

/**
 * Describes the enum od_protos.sell.common.Timeline.
 */
export const TimelineSchema: GenEnum<Timeline, TimelineJson> = /*@__PURE__*/
  enumDesc(file_protobuf_sell_common_common, 1);

/**
 * Partner home builders that refers sellers to us.
 * Next ID: 22
 *
 * @generated from enum od_protos.sell.common.Partnership
 */
export enum Partnership {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: NONE = 1;
   */
  NONE = 1,

  /**
   * @generated from enum value: LENNAR = 2;
   */
  LENNAR = 2,

  /**
   * @generated from enum value: TOLL_BROTHERS = 3;
   */
  TOLL_BROTHERS = 3,

  /**
   * @generated from enum value: MI_HOMES = 4;
   */
  MI_HOMES = 4,

  /**
   * @generated from enum value: MERITAGE = 5;
   */
  MERITAGE = 5,

  /**
   * @generated from enum value: TAYLOR_MORRISON = 6;
   */
  TAYLOR_MORRISON = 6,

  /**
   * @generated from enum value: CHAFIN = 7;
   */
  CHAFIN = 7,

  /**
   * @generated from enum value: SMITHDOUGLAS = 8;
   */
  SMITHDOUGLAS = 8,

  /**
   * @generated from enum value: WOODSIDE = 9;
   */
  WOODSIDE = 9,

  /**
   * @generated from enum value: MATTAMY = 10;
   */
  MATTAMY = 10,

  /**
   * @generated from enum value: RYAN = 11;
   */
  RYAN = 11,

  /**
   * @generated from enum value: PARDEE = 12;
   */
  PARDEE = 12,

  /**
   * @generated from enum value: PULTE = 13;
   */
  PULTE = 13,

  /**
   * @generated from enum value: CALATLANTIC = 14;
   */
  CALATLANTIC = 14,

  /**
   * @generated from enum value: FRONTDOOR = 15;
   */
  FRONTDOOR = 15,

  /**
   * @generated from enum value: GOODALL = 16;
   */
  GOODALL = 16,

  /**
   * @generated from enum value: KB_HOME = 17;
   */
  KB_HOME = 17,

  /**
   * @generated from enum value: OTHER_BUILDER = 18;
   */
  OTHER_BUILDER = 18,

  /**
   * @generated from enum value: CENTURY_COMMUNITIES = 19;
   */
  CENTURY_COMMUNITIES = 19,

  /**
   * @generated from enum value: DAVID_WEEKLEY = 20;
   */
  DAVID_WEEKLEY = 20,

  /**
   * @generated from enum value: SHEA_HOMES_TRILOGY = 21;
   */
  SHEA_HOMES_TRILOGY = 21,

  /**
   * @generated from enum value: DR_HORTON = 22;
   */
  DR_HORTON = 22,
}

/**
 * Partner home builders that refers sellers to us.
 * Next ID: 22
 *
 * @generated from enum od_protos.sell.common.Partnership
 */
export type PartnershipJson = "UNKNOWN" | "NONE" | "LENNAR" | "TOLL_BROTHERS" | "MI_HOMES" | "MERITAGE" | "TAYLOR_MORRISON" | "CHAFIN" | "SMITHDOUGLAS" | "WOODSIDE" | "MATTAMY" | "RYAN" | "PARDEE" | "PULTE" | "CALATLANTIC" | "FRONTDOOR" | "GOODALL" | "KB_HOME" | "OTHER_BUILDER" | "CENTURY_COMMUNITIES" | "DAVID_WEEKLEY" | "SHEA_HOMES_TRILOGY" | "DR_HORTON";

/**
 * Describes the enum od_protos.sell.common.Partnership.
 */
export const PartnershipSchema: GenEnum<Partnership, PartnershipJson> = /*@__PURE__*/
  enumDesc(file_protobuf_sell_common_common, 2);

/**
 * A Product that we can offer to the seller.
 * Next ID: 14
 *
 * @generated from enum od_protos.sell.common.Product
 */
export enum Product {
  /**
   * Product with an unknown name. This should rarely happen
   *
   * @generated from enum value: UNKNOWN_PRODUCT = 0;
   */
  UNKNOWN_PRODUCT = 0,

  /**
   * Sell directly to Opendoor
   *
   * @generated from enum value: OPENDOOR_DIRECT = 1;
   */
  OPENDOOR_DIRECT = 1,

  /**
   * Refer to an agent to help them sell their home
   *
   * @generated from enum value: AGENT_REFERRAL = 2 [deprecated = true];
   * @deprecated
   */
  AGENT_REFERRAL = 2,

  /**
   * Sell to a REIT (Real Estate Investment Trust)
   *
   * @generated from enum value: REIT = 3;
   */
  REIT = 3,

  /**
   * List your home with Opendoor
   *
   * @generated from enum value: LIST_WITH_OPENDOOR = 4 [deprecated = true];
   * @deprecated
   */
  LIST_WITH_OPENDOOR = 4,

  /**
   * Sell directly with upside
   *
   * @generated from enum value: SELL_WITH_UPSIDE = 5;
   */
  SELL_WITH_UPSIDE = 5,

  /**
   * Buy a home from Opendoor
   *
   * @generated from enum value: BUY_WITH_OPENDOOR = 6 [deprecated = true];
   * @deprecated
   */
  BUY_WITH_OPENDOOR = 6,

  /**
   * Make a cash offer on any listed home, using Opendoor cash
   *
   * @generated from enum value: OPENDOOR_BACKED_OFFERS = 7 [deprecated = true];
   * @deprecated
   */
  OPENDOOR_BACKED_OFFERS = 7,

  /**
   * Sell your home on Exclusives
   *
   * @generated from enum value: SELL_WITH_EXCLUSIVES = 8 [deprecated = true];
   * @deprecated
   */
  SELL_WITH_EXCLUSIVES = 8,

  /**
   * List your home and get an Opendoor cash offer as a fallback
   *
   * @generated from enum value: LIST_WITH_CERTAINTY = 9;
   */
  LIST_WITH_CERTAINTY = 9,

  /**
   * Buy a home through an external listing agent
   *
   * @generated from enum value: EXTERNAL_LISTING_AGENT = 10;
   */
  EXTERNAL_LISTING_AGENT = 10,

  /**
   * Home insights dashboard
   *
   * @generated from enum value: HOME_INSIGHTS = 11 [deprecated = true];
   * @deprecated
   */
  HOME_INSIGHTS = 11,

  /**
   * No product selected - used to reset/clear product selection
   *
   * @generated from enum value: NO_PRODUCT = 12;
   */
  NO_PRODUCT = 12,

  /**
   * Sell the home on the MLS with help from Opendoor.
   *
   * @generated from enum value: SELLER_LISTING = 13;
   */
  SELLER_LISTING = 13,
}

/**
 * A Product that we can offer to the seller.
 * Next ID: 14
 *
 * @generated from enum od_protos.sell.common.Product
 */
export type ProductJson = "UNKNOWN_PRODUCT" | "OPENDOOR_DIRECT" | "AGENT_REFERRAL" | "REIT" | "LIST_WITH_OPENDOOR" | "SELL_WITH_UPSIDE" | "BUY_WITH_OPENDOOR" | "OPENDOOR_BACKED_OFFERS" | "SELL_WITH_EXCLUSIVES" | "LIST_WITH_CERTAINTY" | "EXTERNAL_LISTING_AGENT" | "HOME_INSIGHTS" | "NO_PRODUCT" | "SELLER_LISTING";

/**
 * Describes the enum od_protos.sell.common.Product.
 */
export const ProductSchema: GenEnum<Product, ProductJson> = /*@__PURE__*/
  enumDesc(file_protobuf_sell_common_common, 3);

/**
 * @generated from enum od_protos.sell.common.ProductQualificationEvaluationSource
 */
export enum ProductQualificationEvaluationSource {
  /**
   * @generated from enum value: PRODUCT_QUALIFICATION_EVALUATION_SOURCE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: PRODUCT_QUALIFICATION_EVALUATION_SOURCE_ONBOARDING = 1;
   */
  ONBOARDING = 1,

  /**
   * @generated from enum value: PRODUCT_QUALIFICATION_EVALUATION_SOURCE_OFFER_REFRESH = 2;
   */
  OFFER_REFRESH = 2,

  /**
   * @generated from enum value: PRODUCT_QUALIFICATION_EVALUATION_SOURCE_OFFER_REFRESH_PRECHECK = 3;
   */
  OFFER_REFRESH_PRECHECK = 3,

  /**
   * @generated from enum value: PRODUCT_QUALIFICATION_EVALUATION_SOURCE_UNDERWRITING = 4;
   */
  UNDERWRITING = 4,

  /**
   * @generated from enum value: PRODUCT_QUALIFICATION_EVALUATION_SOURCE_SELL_WITH_UPSIDE_ELIGIBILITY = 5;
   */
  SELL_WITH_UPSIDE_ELIGIBILITY = 5,

  /**
   * @generated from enum value: PRODUCT_QUALIFICATION_EVALUATION_SOURCE_MANUAL = 6;
   */
  MANUAL = 6,
}

/**
 * @generated from enum od_protos.sell.common.ProductQualificationEvaluationSource
 */
export type ProductQualificationEvaluationSourceJson = "PRODUCT_QUALIFICATION_EVALUATION_SOURCE_UNKNOWN" | "PRODUCT_QUALIFICATION_EVALUATION_SOURCE_ONBOARDING" | "PRODUCT_QUALIFICATION_EVALUATION_SOURCE_OFFER_REFRESH" | "PRODUCT_QUALIFICATION_EVALUATION_SOURCE_OFFER_REFRESH_PRECHECK" | "PRODUCT_QUALIFICATION_EVALUATION_SOURCE_UNDERWRITING" | "PRODUCT_QUALIFICATION_EVALUATION_SOURCE_SELL_WITH_UPSIDE_ELIGIBILITY" | "PRODUCT_QUALIFICATION_EVALUATION_SOURCE_MANUAL";

/**
 * Describes the enum od_protos.sell.common.ProductQualificationEvaluationSource.
 */
export const ProductQualificationEvaluationSourceSchema: GenEnum<ProductQualificationEvaluationSource, ProductQualificationEvaluationSourceJson> = /*@__PURE__*/
  enumDesc(file_protobuf_sell_common_common, 4);

/**
 * Stage of the offer associated with a product qualification evaluation.
 *
 * @generated from enum od_protos.sell.common.ProductQualificationOfferStage
 */
export enum ProductQualificationOfferStage {
  /**
   * @generated from enum value: PRODUCT_QUALIFICATION_OFFER_STAGE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: PRODUCT_QUALIFICATION_OFFER_STAGE_PRELIMINARY = 1;
   */
  PRELIMINARY = 1,

  /**
   * @generated from enum value: PRODUCT_QUALIFICATION_OFFER_STAGE_FINAL = 2;
   */
  FINAL = 2,
}

/**
 * Stage of the offer associated with a product qualification evaluation.
 *
 * @generated from enum od_protos.sell.common.ProductQualificationOfferStage
 */
export type ProductQualificationOfferStageJson = "PRODUCT_QUALIFICATION_OFFER_STAGE_UNKNOWN" | "PRODUCT_QUALIFICATION_OFFER_STAGE_PRELIMINARY" | "PRODUCT_QUALIFICATION_OFFER_STAGE_FINAL";

/**
 * Describes the enum od_protos.sell.common.ProductQualificationOfferStage.
 */
export const ProductQualificationOfferStageSchema: GenEnum<ProductQualificationOfferStage, ProductQualificationOfferStageJson> = /*@__PURE__*/
  enumDesc(file_protobuf_sell_common_common, 5);

/**
 * Denial reason if the customer was denied for a product.
 * Next ID: 78
 *
 * @generated from enum od_protos.sell.common.DenialReason
 */
export enum DenialReason {
  /**
   * home is not denied
   *
   * @generated from enum value: NO_DENIAL = 0;
   */
  NO_DENIAL = 0,

  /**
   * home is not in a region serviced by Opendoor
   *
   * @generated from enum value: ADDRESS = 1;
   */
  ADDRESS = 1,

  /**
   * home is in an age restricted community
   *
   * @generated from enum value: AGE_RESTRICTED_COMMUNITY = 2;
   */
  AGE_RESTRICTED_COMMUNITY = 2,

  /**
   * home type is not within the set of types purchased by Opendoor
   *
   * @generated from enum value: DWELLING_TYPE = 4;
   */
  DWELLING_TYPE = 4,

  /**
   * home is in a flood zone.
   *
   * @generated from enum value: FLOOD_ZONE = 5;
   */
  FLOOD_ZONE = 5,

  /**
   * home is in a gated community
   *
   * @generated from enum value: GATED_COMMUNITY = 6;
   */
  GATED_COMMUNITY = 6,

  /**
   * home's lot sq ft is too large
   *
   * @generated from enum value: LOT_SQ_FT = 7;
   */
  LOT_SQ_FT = 7,

  /**
   * home has polybutylene piping
   *
   * @generated from enum value: POLYBUTYLENE_PIPING = 8;
   */
  POLYBUTYLENE_PIPING = 8,

  /**
   * home has unpermitted additions
   *
   * @generated from enum value: UNPERMITTED_ADDITION = 9;
   */
  UNPERMITTED_ADDITION = 9,

  /**
   * home's value is outside of buybox range
   *
   * @generated from enum value: VALUATION_TOO_HIGH = 10;
   */
  VALUATION_TOO_HIGH = 10,

  /**
   * home's value is outside of buybox range
   *
   * @generated from enum value: VALUATION_TOO_LOW = 11;
   */
  VALUATION_TOO_LOW = 11,

  /**
   * home has leased solar panels
   *
   * @generated from enum value: LEASED_SOLAR_PANELS = 12;
   */
  LEASED_SOLAR_PANELS = 12,

  /**
   * home has a history of flooding
   *
   * @generated from enum value: FLOOD_HISTORY = 13;
   */
  FLOOD_HISTORY = 13,

  /**
   * home has a septic system
   *
   * @generated from enum value: SEPTIC = 14;
   */
  SEPTIC = 14,

  /**
   * home has a private well as the primary water source
   *
   * @generated from enum value: WELL_WATER = 15;
   */
  WELL_WATER = 15,

  /**
   * home was built too long ago
   *
   * @generated from enum value: YEAR_BUILT = 16;
   */
  YEAR_BUILT = 16,

  /**
   * home has asbestos siding
   *
   * @generated from enum value: ASBESTOS_SIDING = 17;
   */
  ASBESTOS_SIDING = 17,

  /**
   * Opendoor owns the home
   *
   * @generated from enum value: OWNED_BY_OPENDOOR = 18;
   */
  OWNED_BY_OPENDOOR = 18,

  /**
   * Opendoor has listed the home for sale
   *
   * @generated from enum value: LISTED_BY_OPENDOOR = 19;
   */
  LISTED_BY_OPENDOOR = 19,

  /**
   * home is in contract or in contingencies released with Opendoor
   *
   * @generated from enum value: IN_CONTRACT_WITH_OPENDOOR = 20;
   */
  IN_CONTRACT_WITH_OPENDOOR = 20,

  /**
   * other unspecified reason
   *
   * @generated from enum value: OTHER_DENIAL = 22;
   */
  OTHER_DENIAL = 22,

  /**
   * customer is an agent representative of the homeowner
   *
   * @generated from enum value: AGENT_RELATION = 23;
   */
  AGENT_RELATION = 23,

  /**
   * customer is working with a homebuilder partner
   *
   * @generated from enum value: WORKING_WITH_HOMEBUILDER = 24;
   */
  WORKING_WITH_HOMEBUILDER = 24,

  /**
   * buyers are currently unavailable to make an offer on the home
   *
   * @generated from enum value: BUYER_UNAVAILABLE = 25;
   */
  BUYER_UNAVAILABLE = 25,

  /**
   * home has been deemed an outlier at pre-offer time
   *
   * @generated from enum value: OFFER_OUTLIER = 26;
   */
  OFFER_OUTLIER = 26,

  /**
   * @generated from enum value: NOT_IN_AUTODENIAL_LISTING_EXP = 27;
   */
  NOT_IN_AUTODENIAL_LISTING_EXP = 27,

  /**
   * @generated from enum value: NOT_IN_SIDE_BY_SIDE_EXP = 28;
   */
  NOT_IN_SIDE_BY_SIDE_EXP = 28,

  /**
   * seller is working with a partner, could be homebuilder or other
   *
   * @generated from enum value: PARTNERSHIP = 29;
   */
  PARTNERSHIP = 29,

  /**
   * seller is a trade-in customer
   *
   * @generated from enum value: TRADE_IN = 30;
   */
  TRADE_IN = 30,

  /**
   * home has known foundation issues
   *
   * @generated from enum value: FOUNDATION = 31;
   */
  FOUNDATION = 31,

  /**
   * seller is not serious yet
   *
   * @generated from enum value: NON_SERIOUS_SELLER = 32;
   */
  NON_SERIOUS_SELLER = 32,

  /**
   * home has previous or current fire damage
   *
   * @generated from enum value: FIRE_DAMAGE = 33;
   */
  FIRE_DAMAGE = 33,

  /**
   * home does not have adequate comps
   *
   * @generated from enum value: LACK_OF_ADEQUATE_COMPS = 34;
   */
  LACK_OF_ADEQUATE_COMPS = 34,

  /**
   * home dwelling type is not in buybox
   *
   * @generated from enum value: NON_BUYBOX_DWELLING_TYPE = 35;
   */
  NON_BUYBOX_DWELLING_TYPE = 35,

  /**
   * home has high risk factors
   *
   * @generated from enum value: OTHER_HIGH_RISK = 36;
   */
  OTHER_HIGH_RISK = 36,

  /**
   * home is tenant occupied (has lease)
   *
   * @generated from enum value: TENANT_OCCUPIED = 37;
   */
  TENANT_OCCUPIED = 37,

  /**
   * valuation is significantly lower than list price
   *
   * @generated from enum value: VALUATION_TOO_LOW_LISTED = 38;
   */
  VALUATION_TOO_LOW_LISTED = 38,

  /**
   * seasonal age restriction for certain market
   *
   * @generated from enum value: AGE_RESTRICTED_SEASONAL = 39;
   */
  AGE_RESTRICTED_SEASONAL = 39,

  /**
   * home was built before 1960
   *
   * @generated from enum value: BEFORE_1960 = 40;
   */
  BEFORE_1960 = 40,

  /**
   * fees on offer are too high
   *
   * @generated from enum value: FEES_TOO_HIGH = 41;
   */
  FEES_TOO_HIGH = 41,

  /**
   * duplicate lead on address
   *
   * @generated from enum value: DUPLICATE_LEAD = 42;
   */
  DUPLICATE_LEAD = 42,

  /**
   * rejected seller triage documentation
   *
   * @generated from enum value: SELLER_TRIAGE = 43;
   */
  SELLER_TRIAGE = 43,

  /**
   * home has a shared entrance with neighbors
   *
   * @generated from enum value: SHARED_ENTRANCE = 44;
   */
  SHARED_ENTRANCE = 44,

  /**
   * home has a shared lot with neighbors
   *
   * @generated from enum value: SHARED_LOT = 45;
   */
  SHARED_LOT = 45,

  /**
   * already an active offer request for this address, still preparing offer
   *
   * @generated from enum value: PREPARING_OFFER = 46;
   */
  PREPARING_OFFER = 46,

  /**
   * already an active offer for this address
   *
   * @generated from enum value: ACTIVE_OFFER = 47;
   */
  ACTIVE_OFFER = 47,

  /**
   * private pool
   *
   * @generated from enum value: PRIVATE_POOL = 48;
   */
  PRIVATE_POOL = 48,

  /**
   * lead will be passed to external brokerage
   *
   * @generated from enum value: RESERVED_FOR_EXTERNAL_BROKER = 49;
   */
  RESERVED_FOR_EXTERNAL_BROKER = 49,

  /**
   * seller is not in the lwod experiment
   *
   * @generated from enum value: NOT_IN_LWOD_PILOT = 50 [deprecated = true];
   * @deprecated
   */
  NOT_IN_LWOD_PILOT = 50,

  /**
   * pause all acq offers for COVID-19
   *
   * @generated from enum value: COVID_19 = 51;
   */
  COVID_19 = 51,

  /**
   * Not in the Sell w/ Upside experiment
   *
   * @generated from enum value: NOT_IN_SELL_WITH_UPSIDE_PILOT = 52 [deprecated = true];
   * @deprecated
   */
  NOT_IN_SELL_WITH_UPSIDE_PILOT = 52,

  /**
   * opendoor cannot value the home.
   *
   * @generated from enum value: UNABLE_TO_VALUE = 53;
   */
  UNABLE_TO_VALUE = 53,

  /**
   * they were also denied for sell_with_upside, so they're not eligible for this other product
   *
   * @generated from enum value: DENIED_FOR_SELL_WITH_UPSIDE = 54;
   */
  DENIED_FOR_SELL_WITH_UPSIDE = 54,

  /**
   * they're qualified for list with opendoor, which is incompatible with this product
   *
   * @generated from enum value: QUALIFIED_FOR_LWOD = 55 [deprecated = true];
   * @deprecated
   */
  QUALIFIED_FOR_LWOD = 55,

  /**
   * they were also denied for opendoor_direct, so they're not eligible for this other product
   *
   * @generated from enum value: DENIED_FOR_OPENDOOR_DIRECT = 56;
   */
  DENIED_FOR_OPENDOOR_DIRECT = 56,

  /**
   * they're qualified for opendoor direct, which is incompatible with this product
   *
   * @generated from enum value: QUALIFIED_FOR_OPENDOOR_DIRECT = 57;
   */
  QUALIFIED_FOR_OPENDOOR_DIRECT = 57,

  /**
   * home is in a guard-gated community
   *
   * @generated from enum value: GUARD_GATED_COMMUNITY = 58;
   */
  GUARD_GATED_COMMUNITY = 58,

  /**
   * livestock on property
   *
   * @generated from enum value: LIVESTOCK = 62;
   */
  LIVESTOCK = 62,

  /**
   * mobile or manufactured home
   *
   * @generated from enum value: MOBILE_MANUFACTURED_HOME = 63;
   */
  MOBILE_MANUFACTURED_HOME = 63,

  /**
   * this address has been explicitly denied
   *
   * @generated from enum value: ADDRESS_OVERRIDE = 59;
   */
  ADDRESS_OVERRIDE = 59,

  /**
   * sale timeline is not compatible with the experience
   *
   * @generated from enum value: SALE_TIMELINE = 65;
   */
  SALE_TIMELINE = 65,

  /**
   * expected levered gross margin (LGM) does not meet experience criteria
   *
   * @generated from enum value: EXPECTED_LGM = 66;
   */
  EXPECTED_LGM = 66,

  /**
   * tenants in common, co-op programs
   *
   * @generated from enum value: UNIQUE_OWNERSHIP_STRUCTURE = 68;
   */
  UNIQUE_OWNERSHIP_STRUCTURE = 68,

  /**
   * San Francisco-specific program for low-middle income buyers
   *
   * @generated from enum value: BELOW_MARKET_RATE_OWNERSHIP = 69;
   */
  BELOW_MARKET_RATE_OWNERSHIP = 69,

  /**
   * NY/NJ specific - homes commonly have underground oil tanks that can be costly
   *
   * @generated from enum value: UNDERGROUND_OIL_TANK = 70;
   */
  UNDERGROUND_OIL_TANK = 70,

  /**
   * For use with partner API, controls display of OD offers in partner's website UI
   *
   * @generated from enum value: MLS_LISTING_STATUS = 71;
   */
  MLS_LISTING_STATUS = 71,

  /**
   * Boston and NY/NJ only, for homes with a cesspool
   *
   * @generated from enum value: CESSPOOL = 72;
   */
  CESSPOOL = 72,

  /**
   * home is in an ineligible HOA - requires rental history, SSN, etc.
   *
   * @generated from enum value: INELIGIBLE_HOA = 73;
   */
  INELIGIBLE_HOA = 73,

  /**
   * Deprecated, used only for the ShouldDenyBasedOnFlipStatus web GRPC endpoint
   *
   * @generated from enum value: OFFER_IN_PROGRESS = 64 [deprecated = true];
   * @deprecated
   */
  OFFER_IN_PROGRESS = 64,

  /**
   * denial code used externally to present that we have some uncategorized
   * reason for denying a given address for a given product.
   *
   * @generated from enum value: OTHER_DENIAL_GENERAL = 60;
   */
  OTHER_DENIAL_GENERAL = 60,

  /**
   * denial code used externally to present that we are missing a
   * particular piece of information necessary to value a home.
   * For backwards compatibility this denial_reason does not
   * have a more reasonable name like OTHER_DENIAL_VALUATION
   *
   * @generated from enum value: OTHER_DENIAL_DETAIL = 61;
   */
  OTHER_DENIAL_DETAIL = 61,

  /**
   * dependent ruleset evaluation is incompatible with this product
   *
   * @generated from enum value: DEPENDENT_RULESET = 67;
   */
  DEPENDENT_RULESET = 67,

  /**
   * the home is in a region that Pricing has deemed too risky
   *
   * @generated from enum value: RISK_PROHIBITED_REGION = 74;
   */
  RISK_PROHIBITED_REGION = 74,

  /**
   * the product is not active in the current market
   *
   * @generated from enum value: PRODUCT_INACTIVE = 75;
   */
  PRODUCT_INACTIVE = 75,

  /**
   * @generated from enum value: PRODUCT_NOT_IN_EXPERIMENT = 76;
   */
  PRODUCT_NOT_IN_EXPERIMENT = 76,

  /**
   * home has a recent Opendoor underwriting walk
   *
   * @generated from enum value: RECENT_OPENDOOR_WALK = 77;
   */
  RECENT_OPENDOOR_WALK = 77,
}

/**
 * Denial reason if the customer was denied for a product.
 * Next ID: 78
 *
 * @generated from enum od_protos.sell.common.DenialReason
 */
export type DenialReasonJson = "NO_DENIAL" | "ADDRESS" | "AGE_RESTRICTED_COMMUNITY" | "DWELLING_TYPE" | "FLOOD_ZONE" | "GATED_COMMUNITY" | "LOT_SQ_FT" | "POLYBUTYLENE_PIPING" | "UNPERMITTED_ADDITION" | "VALUATION_TOO_HIGH" | "VALUATION_TOO_LOW" | "LEASED_SOLAR_PANELS" | "FLOOD_HISTORY" | "SEPTIC" | "WELL_WATER" | "YEAR_BUILT" | "ASBESTOS_SIDING" | "OWNED_BY_OPENDOOR" | "LISTED_BY_OPENDOOR" | "IN_CONTRACT_WITH_OPENDOOR" | "OTHER_DENIAL" | "AGENT_RELATION" | "WORKING_WITH_HOMEBUILDER" | "BUYER_UNAVAILABLE" | "OFFER_OUTLIER" | "NOT_IN_AUTODENIAL_LISTING_EXP" | "NOT_IN_SIDE_BY_SIDE_EXP" | "PARTNERSHIP" | "TRADE_IN" | "FOUNDATION" | "NON_SERIOUS_SELLER" | "FIRE_DAMAGE" | "LACK_OF_ADEQUATE_COMPS" | "NON_BUYBOX_DWELLING_TYPE" | "OTHER_HIGH_RISK" | "TENANT_OCCUPIED" | "VALUATION_TOO_LOW_LISTED" | "AGE_RESTRICTED_SEASONAL" | "BEFORE_1960" | "FEES_TOO_HIGH" | "DUPLICATE_LEAD" | "SELLER_TRIAGE" | "SHARED_ENTRANCE" | "SHARED_LOT" | "PREPARING_OFFER" | "ACTIVE_OFFER" | "PRIVATE_POOL" | "RESERVED_FOR_EXTERNAL_BROKER" | "NOT_IN_LWOD_PILOT" | "COVID_19" | "NOT_IN_SELL_WITH_UPSIDE_PILOT" | "UNABLE_TO_VALUE" | "DENIED_FOR_SELL_WITH_UPSIDE" | "QUALIFIED_FOR_LWOD" | "DENIED_FOR_OPENDOOR_DIRECT" | "QUALIFIED_FOR_OPENDOOR_DIRECT" | "GUARD_GATED_COMMUNITY" | "LIVESTOCK" | "MOBILE_MANUFACTURED_HOME" | "ADDRESS_OVERRIDE" | "SALE_TIMELINE" | "EXPECTED_LGM" | "UNIQUE_OWNERSHIP_STRUCTURE" | "BELOW_MARKET_RATE_OWNERSHIP" | "UNDERGROUND_OIL_TANK" | "MLS_LISTING_STATUS" | "CESSPOOL" | "INELIGIBLE_HOA" | "OFFER_IN_PROGRESS" | "OTHER_DENIAL_GENERAL" | "OTHER_DENIAL_DETAIL" | "DEPENDENT_RULESET" | "RISK_PROHIBITED_REGION" | "PRODUCT_INACTIVE" | "PRODUCT_NOT_IN_EXPERIMENT" | "RECENT_OPENDOOR_WALK";

/**
 * Describes the enum od_protos.sell.common.DenialReason.
 */
export const DenialReasonSchema: GenEnum<DenialReason, DenialReasonJson> = /*@__PURE__*/
  enumDesc(file_protobuf_sell_common_common, 6);

/**
 * Segments that classify types of sellers
 * Next ID: 5
 *
 * @generated from enum od_protos.sell.common.Segment
 */
export enum Segment {
  /**
   * @generated from enum value: HOMEOWNER = 0;
   */
  HOMEOWNER = 0,

  /**
   * @generated from enum value: WORKING_WITH_AGENT = 1;
   */
  WORKING_WITH_AGENT = 1,

  /**
   * @generated from enum value: BUYER = 2;
   */
  BUYER = 2,

  /**
   * @generated from enum value: HOMEBUILDER = 3;
   */
  HOMEBUILDER = 3,

  /**
   * @generated from enum value: STAYING_IN_MARKET = 4;
   */
  STAYING_IN_MARKET = 4,
}

/**
 * Segments that classify types of sellers
 * Next ID: 5
 *
 * @generated from enum od_protos.sell.common.Segment
 */
export type SegmentJson = "HOMEOWNER" | "WORKING_WITH_AGENT" | "BUYER" | "HOMEBUILDER" | "STAYING_IN_MARKET";

/**
 * Describes the enum od_protos.sell.common.Segment.
 */
export const SegmentSchema: GenEnum<Segment, SegmentJson> = /*@__PURE__*/
  enumDesc(file_protobuf_sell_common_common, 7);

/**
 * SelfServiceVirtualAssessmentExperimentGroup determines what experiment group the seller is in with regards to the Self Service
 * Virtual Assessment Experiment, where the seller has the option to upload a set of recordings of their home
 * in order to finalize their headline price. Depending on what group the seller falls into will determine
 * the user experience in terms of how they're presented with this option.
 * Next ID: 6
 *
 * @generated from enum od_protos.sell.common.SelfServiceVirtualAssessmentExperimentGroup
 */
export enum SelfServiceVirtualAssessmentExperimentGroup {
  /**
   * Seller is not in the experiment.
   *
   * @generated from enum value: NOT_IN_EXPERIMENT = 0;
   */
  NOT_IN_EXPERIMENT = 0,

  /**
   * Seller is presented with both uploading the self service and scheduling a virtual assessment call with no
   * bias towards either option.
   *
   * @generated from enum value: BALANCED = 1;
   */
  BALANCED = 1,

  /**
   * Seller is presented with a heavier bias towards the self service option, and must explicitly opt out
   * of that experience.
   *
   * @generated from enum value: ASSERTIVE = 2;
   */
  ASSERTIVE = 2,

  /**
   * Seller is in the control group of the experiment
   *
   * @generated from enum value: CONTROL = 3;
   */
  CONTROL = 3,

  /**
   * Agent is presented the self-serve virtual assessment option with a heavier bias towards self-service.
   *
   * @generated from enum value: AGENT_ASSERTIVE = 4;
   */
  AGENT_ASSERTIVE = 4,

  /**
   * Agent is in the control group of the experiment
   *
   * @generated from enum value: AGENT_CONTROL = 5;
   */
  AGENT_CONTROL = 5,
}

/**
 * SelfServiceVirtualAssessmentExperimentGroup determines what experiment group the seller is in with regards to the Self Service
 * Virtual Assessment Experiment, where the seller has the option to upload a set of recordings of their home
 * in order to finalize their headline price. Depending on what group the seller falls into will determine
 * the user experience in terms of how they're presented with this option.
 * Next ID: 6
 *
 * @generated from enum od_protos.sell.common.SelfServiceVirtualAssessmentExperimentGroup
 */
export type SelfServiceVirtualAssessmentExperimentGroupJson = "NOT_IN_EXPERIMENT" | "BALANCED" | "ASSERTIVE" | "CONTROL" | "AGENT_ASSERTIVE" | "AGENT_CONTROL";

/**
 * Describes the enum od_protos.sell.common.SelfServiceVirtualAssessmentExperimentGroup.
 */
export const SelfServiceVirtualAssessmentExperimentGroupSchema: GenEnum<SelfServiceVirtualAssessmentExperimentGroup, SelfServiceVirtualAssessmentExperimentGroupJson> = /*@__PURE__*/
  enumDesc(file_protobuf_sell_common_common, 8);

